import { useState, useMemo, useCallback } from 'sb-hooks'


type Input<T> = {
  products: T[]
  countToShow: number
}

type Output<T> = {
  shortProducts: Input<T>['products']
  onShowMoreProducts: () => void
  withShowMoreButton: boolean
}

const useShowMore = <T extends object>(values: Input<T>): Output<T> => {
  const { products, countToShow } = values

  const [ productsCount, setProductsCount ] = useState<number>(countToShow)

  const onShowMoreProducts = useCallback(() => {
    if (!productsCount) {
      return
    }

    setProductsCount((count) => count + countToShow)
  }, [ productsCount, countToShow ])

  const { shortProducts, withShowMoreButton } = useMemo(() => {
    let shortProducts = products
    let withShowMoreButton = false

    if (products && productsCount) {
      shortProducts = products.slice(0, productsCount)
      withShowMoreButton = Boolean(productsCount && productsCount < products.length)
    }

    return {
      shortProducts,
      withShowMoreButton,
    }
  }, [ products, productsCount ])

  return {
    shortProducts,
    onShowMoreProducts,
    withShowMoreButton,
  }
}


export default useShowMore
